import { TimetableResponseDto } from "../shared/dtos/timetable/TimetableResponseDto";
import { TimetableSummaryDto } from "../shared/dtos/timetable/TimetableSummaryDto";

export class TimetableMapper {
  public static mapTimetableToSummary(
    timetable: TimetableResponseDto,
  ): TimetableSummaryDto {
    return {
      id: timetable.id,
      name: timetable.name,
      classroomId: timetable.classroomId,
      classroomName: timetable.classroomName,
      gradeLevelId: timetable.gradeLevelId,
      gradeLevelName: timetable.gradeLevelName,
      termId: timetable.termId,
      termName: timetable.termName,
      academicYearId: timetable.academicYearId,
      academicYearName: timetable.academicYearName,
      branchId: timetable.branchId,
      branchName: timetable.branchName,
      status: timetable.status,
      createdAt: timetable.createdAt,
    };
  }
}
